import React from "react";

const LazyRegister = React.lazy(() => import("./register"));

const Register = (props: Record<string, any>) => (
  <React.Suspense fallback={<div className='transition-loader'><img src='/images/loader.svg' /></div>}>
    <LazyRegister {...props} />
  </React.Suspense>
);

export default Register;
